import React, { FC } from 'react';
import TopicList from './topic-list';

interface Props {
    className?: string;
}

const ItemContentTabTwo: FC<Props> = ({ children, className }) => {

    return <div className="flex flex-row flex-grow min-h-0 overflow-hidden mt-4 mb-16">
        <TopicList />
        <div className={`flex flex-column flex-grow ml-4 ${className ? className : ''}`}>{children}</div>
    </div>;
};

export default ItemContentTabTwo;

